export default __webpack_public_path__ + "static/media/NL_parcours_1_carte_5.6d4941c6.png";